import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

export default function useBackWithFallback(fallback: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    () => (location.key === "default" ? navigate(fallback) : navigate(-1)),
    [navigate, location, fallback]
  );
}
